import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "@/pages/LandingPage";
import AdminLeads from "@/pages/AdminLeads";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/i18n";

function App() {
  useEffect(() => {
    document.title = "Madeira.com.pl – Wakacje, wycieczki i obozy na Maderze";
  }, []);

  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/admin/leads" element={<AdminLeads />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </LanguageProvider>
    </div>
  );
}

export default App;
